import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-triangle",
  style: {"color":"var(--red-500)","font-size":"2rem"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-triangle",
  style: {"color":"var(--yellow-500)","font-size":"2rem"}
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-question-circle",
  style: {"color":"var(--blue-500)","font-size":"2rem"}
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("select", {
  class: "ql-size",
  style: {"width":"120px"}
}, [
  /*#__PURE__*/_createElementVNode("option", { value: "small" }, "Маленький"),
  /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Нормальный"),
  /*#__PURE__*/_createElementVNode("option", { value: "large" }, "Большой"),
  /*#__PURE__*/_createElementVNode("option", { value: "huge" }, "Огромный")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "ql-bold" }),
  /*#__PURE__*/_createElementVNode("button", { class: "ql-italic" }),
  /*#__PURE__*/_createElementVNode("button", { class: "ql-underline" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-list",
    type: "button",
    value: "ordered"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "ql-list",
    type: "button",
    value: "bullet"
  }),
  /*#__PURE__*/_createElementVNode("select", { class: "ql-align" }, [
    /*#__PURE__*/_createElementVNode("option", { defaultValue: "" }),
    /*#__PURE__*/_createElementVNode("option", { value: "center" }),
    /*#__PURE__*/_createElementVNode("option", { value: "right" }),
    /*#__PURE__*/_createElementVNode("option", { value: "justify" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_Button = _resolveComponent("Button")!
  const _component_XModal = _resolveComponent("XModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_XModal, {
      ref: "XModal",
      "show-overlay": $data.showOverlay,
      onHide: $options.onHide
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            ($data.iconType === 'error')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_5))
              : ($data.iconType === 'warning')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_9))
                : ($data.iconType === 'question')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_13))
                  : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, _toDisplayString($data.modalInfoHeader), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          style: {"min-width":"200px"},
          innerHTML: $data.modalInfoContent
        }, null, 8, _hoisted_14),
        ($data.showInputText)
          ? (_openBlock(), _createBlock(_component_InputText, {
              key: 0,
              ref: "InputText",
              modelValue: $data.inputTextValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.inputTextValue) = $event)),
              placeholder: $data.inputTextPlaceholder,
              autofocus: "",
              class: "w-full mt-3"
            }, null, 8, ["modelValue", "placeholder"]))
          : _createCommentVNode("", true),
        ($data.showInputTextArea)
          ? (_openBlock(), _createBlock(_component_Editor, {
              key: 1,
              ref: "Editor",
              modelValue: $data.inputTextValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.inputTextValue) = $event)),
              placeholder: $data.inputTextPlaceholder,
              class: "mt-3 w-full",
              editorStyle: "height: 220px; width: 50vw;"
            }, {
              toolbar: _withCtx(() => [
                _hoisted_15,
                _hoisted_16,
                _hoisted_17
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        ($data.showHideBtn)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              autofocus: "",
              class: "p-button-outlined",
              label: "Ок",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$refs.XModal.hide()))
            }))
          : _createCommentVNode("", true),
        ($data.showOkBtn)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              label: $data.okBtnText,
              class: "p-button-outlined p-button-success",
              onClick: $options.success
            }, null, 8, ["label", "onClick"]))
          : _createCommentVNode("", true),
        ($data.showCancelBtn)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              label: $data.cancelBtnText,
              class: "p-button-outlined",
              onClick: $options.cancel
            }, null, 8, ["label", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show-overlay", "onHide"])
  ]))
}